<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div mat-dialog-title>
  {{ data.article.name }}
  <button mat-icon-button (click)="handleMoreIsComplete(false)" title="Cancel" class="close-button" tabindex="-1">
    <mat-icon class="mdi-24px center-self" fontIcon="mdi-close-circle-outline"></mat-icon>
  </button>
  <button mat-icon-button (click)="handleMoreIsComplete(true)" title="Open in new tab" class="close-button"
    tabindex="1">
    <mat-icon class="mdi-24px center-self" fontIcon="mdi-open-in-new"></mat-icon>
  </button>
</div>

@if (data.useUrl && safeUrl) {
<div mat-dialog-content class="container">
  <iframe [src]="safeUrl" class="responsive-iframe"></iframe>
</div>
}

@if (!data.useUrl && data.article && data.article.description) {
<div mat-dialog-content class="page">
  <angular-editor class="angular-editor" [ngModel]="data.article.description" [config]="editorConfig"></angular-editor>
</div>
}
